import React, { useContext } from "react";
import { Navigate, useNavigate, useSearchParams } from "react-router-dom";
import { ProductContext } from "../../../store";
import DetailSkeleton from "../../../components/Skeleton/DetailSkeleton";
import MonitoringWritingAssistant from "../../../components/AiVisibility/Monitoring/MonitoringWritingAssistant";
import { safeReturnTo } from "../../../components/AiVisibility/auditUtils";
import { SETTINGS_BASE } from "./ContentStudioSettings";

const LEGACY_SETTINGS_TABS = new Set(["personas", "guidelines"]);

const AiVisibilityMonitoringWritingAssistance = () => {
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const returnTo = safeReturnTo(searchParams.get("returnTo"));
	const tabParam = searchParams.get("tab");
	const runIdValue = searchParams.get("runId");
	const parsedRunId =
		runIdValue != null && runIdValue !== "" ? Number(runIdValue) : null;
	const hasRun = Number.isFinite(parsedRunId);
	const { currentWebsiteId, userLoader, websiteLoader } = useContext(ProductContext);

	if (LEGACY_SETTINGS_TABS.has(tabParam)) {
		const next = new URLSearchParams();
		if (tabParam !== "personas") {
			next.set("tab", tabParam);
		}
		if (returnTo) {
			next.set("returnTo", returnTo);
		}
		const query = next.toString();
		return (
			<Navigate
				to={query ? `${SETTINGS_BASE}?${query}` : SETTINGS_BASE}
				replace
			/>
		);
	}

	if (userLoader || websiteLoader) {
		return <DetailSkeleton />;
	}

	if (!currentWebsiteId) {
		return (
			<div className="contentBlock ai-visibility-dashboard">
				<p className="text-muted mb-0">Select a website to use AI Writing Assistant.</p>
			</div>
		);
	}

	return (
		<div className="contentBlock ai-visibility-dashboard monitoring-page">
			<div className="monitoring">
				<div className="monitoring__page-header monitoring__page-header--stacked mb-3">
					{!hasRun && returnTo ? (
						<button
							type="button"
							className="monitoring__writing-toolbar-back mb-2"
							onClick={() => navigate(returnTo)}
						>
							<i className="fas fa-arrow-left me-2" aria-hidden />
							Back to Content Strategy
						</button>
					) : null}
					<h2 className="monitoring__page-title mb-0">AI Writing Assistant</h2>
					<p className="monitoring__page-lead mb-0">
						Create or optimize pages, and review drafts from monitoring recommendations.
					</p>
				</div>
				<MonitoringWritingAssistant websiteId={currentWebsiteId} />
			</div>
		</div>
	);
};

export default AiVisibilityMonitoringWritingAssistance;
